import Accordion from "@//module/accordion";
import Carousel from "@//module/carousel";
import fadeUpAnimation from "@//module/fadeUpAnimation";
import ImgAnimation from "@//module/imgAnimation";
import Menu from "@//module/menu";
import Top from "@//pages/top";
import Base from "@//utils/Base";

class AppClass {
  private _top: HTMLElement | null;
  private _a: HTMLCollectionOf;
  private _header: HTMLElement | null;
  constructor() {
    // class変数
    this._top = Base._d.getElementById("data-top");
    this._a = Base._d.getElementsByTagName("a");
    this._header = Base._d.getElementById("data-header");
    this.init();
  }
  public init = () => {
    // 以下共通で追加するEVENT
    if (this._top) {
      new Top();
    }
    new fadeUpAnimation();
    new ImgAnimation();
    new Menu();
    new Accordion();
    new Carousel();
  };
}
window.onload = () => {
  new AppClass();
};
